import React, { useState } from "react";
import API from "../../ApiService/ApiService";
import Context from "./index";
// clinic provider

const ClinicProvider = (props) => {
  const api = new API();
  const [clinicData, setClinicData] = useState("");
  const [ClinicLoader, setClinicLoader] = useState(false);

  const [selectedClinicData, setSelectedClinicData] = useState({
    clinicId: "",
    doctorId: "",
    doctorName: "",
  });

  const getClinicData = async (slug) => {
    const url = "clinic/clinic_search";
    setClinicLoader(true);
    await api.getAll(url, { clinic_slug: slug }, (err, res) => {
      if (res?.data?.status === 200) {
        console.log("Fetched Clinic Data:", res?.data?.data);
        const data = res?.data?.data;
        setClinicData(data); // Store data in state
      } else {
        console.error("Error fetching data:", err);
      }
      setClinicLoader(false);
    });
  };

  return (
    <Context.Provider
      value={{
        clinicData,
        setClinicData,
        getClinicData,
        ClinicLoader,
        selectedClinicData,
        setSelectedClinicData,
        ...props,
      }}
    >
      {props.children}
    </Context.Provider>
  );
};

export default ClinicProvider;
